import { useTheme } from 'styled-components';

import { getPath } from '@speeki/client-admin';
import { useCheckFlag } from '@speeki/feature-flags';
import { Skeleton } from '@speeki/global-ui-components';

import { CardLink } from '@components/atoms/CardLink/CardLink';
import { PlaceholderCard } from '@components/atoms/PlaceholderCard/PlaceholderCard';
import { QuestionnaireStatistic } from '@components/molecules/QuestionnaireStatistic/QuestionnaireStatistic';
import {
    ActionWrapper,
    ProgressWrapper,
    StatisticHeader,
} from '@components/molecules/StatisticsCards/StatisticsCards.styled';
import { StatisticsRiskArea } from '@components/organisms/Statistics/useStatistics';

interface EsgProgrammesCardProps {
    gridSize: number;
    hidden: boolean;
    loading: boolean;
    riskAreas: StatisticsRiskArea[];
}

export const EsgProgrammesCard = ({
    gridSize,
    hidden,
    loading,
    riskAreas,
}: EsgProgrammesCardProps) => {
    const { palette } = useTheme();

    const isNewDashboardFeature = useCheckFlag(
        'client-admin_new-dashboard_20250625',
    );

    return (
        <PlaceholderCard
            gridSize={isNewDashboardFeature ? gridSize : 1}
            hidden={hidden}
        >
            <StatisticHeader>
                <PlaceholderCard.Title>Your Programmes</PlaceholderCard.Title>
                <PlaceholderCard.Description>
                    Track your programmes completion and progress.
                </PlaceholderCard.Description>
            </StatisticHeader>
            <ProgressWrapper>
                {loading
                    ? Array(3)
                          .fill(0)
                          .map((_, index) => (
                              <Skeleton
                                  height={40}
                                  key={index}
                                  width={'100%'}
                              />
                          ))
                    : riskAreas.map((riskArea) => (
                          <QuestionnaireStatistic
                              categoryName={riskArea.categoryName}
                              key={riskArea.name}
                              link={getPath({
                                  params: {
                                      programmeId: riskArea.programmeId,
                                      riskAreaUuid: riskArea.uuid,
                                  },
                                  path: '/programmes/:programmeId/:riskAreaUuid',
                              })}
                              loading={!riskAreas.length}
                              progressIndicator={{
                                  backgroundColor: palette.neutral.gray,
                                  progressColor:
                                      palette.esg[
                                          `${riskArea.categoryName}New`
                                      ],
                              }}
                              statistics={{
                                  allQuestions:
                                      riskArea.statistics.totalQuestions,
                                  filledQuestions:
                                      riskArea.statistics.answeredQuestions,
                              }}
                              title={riskArea.name}
                          />
                      ))}
            </ProgressWrapper>
            <ActionWrapper>
                <CardLink
                    href={getPath({
                        path: '/programmes',
                    })}
                >
                    Go to My programmes
                </CardLink>
            </ActionWrapper>
        </PlaceholderCard>
    );
};
